import { ButtonTheme } from '@sternum/ui';

export function padding({ size, withIcon, iconPosition }: ButtonTheme.ButtonVariantThemeParams) {
  if (size === 'large') {
    return `
      ${9}px
      ${withIcon ? (iconPosition === 'left' ? 16 : 12) : 16}px
      ${9}px
      ${withIcon ? (iconPosition === 'left' ? 12 : 16) : 16}px
    `;
  }

  return `
      ${7}px
      ${withIcon ? (iconPosition === 'left' ? 16 : 12) : 16}px
      ${7}px
      ${withIcon ? (iconPosition === 'left' ? 12 : 16) : 16}px
  `;
}
